import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    // ---------------------青瓷客服中心 开始----------------------
    {
      path: '/',
      meta: { title: '账号中心' },
      component: () => import('@/CustomerService/ServiceCenter/index')
    },
    {
      path: '/online',
      meta: { title: '七鱼客服' },
      component: () => import('@/CustomerService/Online/index')
    },
    {
      path: '/ForgetAccount/',
      meta: { title: '账号自助中心 | 账户找回' },
      component: () => import('@/CustomerService/ForgetAccount/index')
    },
    {
      path: '/ForgetPassword/',
      meta: { title: '账号自助中心 | 密码找回' },
      component: () => import('@/CustomerService/ForgetPassword/index')
    },
    {
      path: '/AppealChoice/',
      meta: { title: '账号自助中心 | 账号申诉选择' },
      component: () => import('@/CustomerService/AppealChoice/index')
    },
    {
      path: '/Appeal/',
      meta: { title: '账号自助中心 | 账号申诉' },
      component: () => import('@/CustomerService/Appeal/index')
    },
    {
      path: '/AppealQuery/',
      meta: { title: '账号自助中心 | 申诉查询' },
      component: () => import('@/CustomerService/AppealQuery/index')
    },
    {
      path: '/Cancellation/',
      meta: { title: '账号自助中心 | 账号注销' },
      component: () => import('@/CustomerService/Cancellation/index')
    },
    {
      path: '/CancellationQuery/',
      meta: { title: '账号自助中心 | 注销查询' },
      component: () => import('@/CustomerService/CancellationQuery/index')
    },
    {
      path: '/Juveniles/',
      meta: { title: '账号自助中心 | 退款申请' },
      component: () => import('@/CustomerService/Juveniles/index')
    },
    {
      path: '/JuvenilesList/',
      meta: { title: '账号自助中心 | 退款申请' },
      component: () => import('@/CustomerService/JuvenilesList/index')
    },
    {
      path: '/JuvenilesQuery/',
      meta: { title: '账号自助中心 | 退费进度查询' },
      component: () => import('@/CustomerService/JuvenilesQuery/index')
    },
    {
      path: '/JuvenilesCollect/',
      meta: { title: '账号自助中心 | 申请人收款账户收集' },
      component: () => import('@/CustomerService/JuvenilesCollect/index')
    },
    {
      path: '/JuvenilesRefundList/',
      meta: { title: '账号自助中心 | 退款列表' },
      component: () => import('@/CustomerService/JuvenilesRefundList/index')
    },
    {
      path: '/FileDownload/',
      meta: { title: '账号自助中心 | 材料下载' },
      component: () => import('@/CustomerService/FileDownload/index')
    },
    {
      path: '/Violation/',
      meta: { title: '账号自助中心 | 违规申诉' },
      name: 'index',
      component: () => import('@/CustomerService/Violation/index')
    },
    {
      path: '/ViolationQuery/',
      meta: { title: '账号自助中心 | 违规申诉查询' },
      component: () => import('@/CustomerService/ViolationQuery/index')
    },
    {
      path: '/PasswordReset/',
      meta: { title: '账号自助中心 | 密码重置' },
      component: () => import('@/CustomerService/PasswordReset/index')
    },
    {
      path: '/Invoice/',
      meta: { title: '账号自助中心 | 开具发票' },
      component: () => import('@/CustomerService/Invoice/index')
    },
    {
      path: '/AccountReplace',
      meta: { title: '账号自助中心 | 账号换绑' },
      component: () => import('@/CustomerService/AccountReplace/index')
    },
    {
      path: '/Refund*',
      meta: { title: '青瓷游戏关服退款处理' },
      component: () => import('@/CustomerService/Refund/index')
    },
    // ---------------------青瓷客服中心 结束----------------------

    // ---------------------家长守护平台 开始----------------------
    {
      path: '/ParentsAccompany/',
      meta: { title: '青瓷家长守护平台_青瓷游戏官方网站' },
      component: () => import('@/Guardian/ParentsAccompany/index')
    },
    {
      path: '/Accompany/',
      meta: { title: '青瓷家长守护平台_青瓷游戏官方网站' },
      component: () => import('@/Guardian/Accompany/index')
    },
    {
      path: '/Help/',
      meta: { title: '青瓷家长守护平台_青瓷游戏官方网站' },
      component: () => import('@/Guardian/Help/index')
    },
    // ---------------------家长守护平台 结束----------------------

    // ------------------家长守护平台-移动端 开始------------------
    {
      path: '/Leading',
      meta: { title: '青瓷家长守护平台' },
      component: () => import('@/Wechat/Leading/index')
    },
    {
      path: '/Logon',
      meta: { title: '青瓷家长守护平台 | 登录' },
      component: () => import('@/Wechat/Logon/index')
    },
    {
      path: '/ParentInfo',
      meta: { title: '青瓷家长守护平台 | 家长守护' },
      component: () => import('@/Wechat/ParentInfo/index')
    },
    {
      path: '/Guard',
      meta: { title: '青瓷家长守护平台 | 家长守护' },
      component: () => import('@/Wechat/Guard/index')
    },
    {
      path: '/Details',
      meta: { title: '青瓷家长守护平台 | 家长守护' },
      component: () => import('@/Wechat/Details/index')
    },
    {
      path: '/Limit',
      meta: { title: '青瓷家长守护平台 | 家长守护' },
      component: () => import('@/Wechat/Limit/index')
    },
    {
      path: '/Family',
      meta: { title: '青瓷家长守护平台 | 我的家庭' },
      component: () => import('@/Wechat/Family/index')
    },
    {
      path: '/AddMember',
      meta: { title: '青瓷家长守护平台 | 添加成员' },
      component: () => import('@/Wechat/AddMember/index')
    },

    // ------------------家长守护平台-移动端 结束------------------

    // 注册功能暂时不使用
    {
      path: '/Register/',
      meta: { title: '账号自助中心 | 注册' },
      component: () => import('@/CustomerService/Register/index')
    },
    {
      path: '/*',
      meta: { title: '页面未找到' },
      component: () => import('@/CustomerService/404/index')
    }
  ]
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js